import React, { Component } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row
} from 'reactstrap'
import {
  AppAside,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarNav
} from '@coreui/react'
import navigation from '../../_nav'
import routes from '../../routes'
import DefaultAside from './DefaultAside'
import DefaultFooter from './DefaultFooter'
import DefaultHeader from './DefaultHeader'
import 'react-toastify/dist/ReactToastify.min.css'
import { toast, ToastContainer } from 'react-toastify'
import { getSessionData } from '../../services/session/authConfig'
import { getSystemConfig } from '../../services/session/systemConfig'
import { getCurrentAccount, getCurrentFullViewState } from '../../services/session/sessionState'
import { addZero } from '../../services/Functions'
import AuthContext from '../../msal'
import axios from 'axios'
import { getPendingAppointments } from '../../api/appointments.service'
import { sendActivityLog } from '../../api/activityLog.service'
import moment from 'moment/moment'
import { events, pages, sections } from '../../constants/ActivityLog'

const { detect } = require('detect-browser')

const Reason = [
  'Contacto ausente',
  'No necesita pedido',
  'Pasará pedido',
  'Captación',
  'Pedido manual',
  'Pedido de cliente',
  'Incidencia',
  'Merchandising',
  'Gestión de cobros'
]

class DefaultLayout extends Component {
  static contextType = AuthContext

  constructor(props, context) {
    super(props, context)

    this.renderContactBreadcrumb = this.renderContactBreadcrumb.bind(this)
    this.handleClickLinkPortal = this.handleClickLinkPortal.bind(this)
    this.renderLinkDiasPedido = this.renderLinkDiasPedido.bind(this)
    this.renderLinkPedido1 = this.renderLinkPedido1.bind(this)
    this.renderLinkPedido2 = this.renderLinkPedido2.bind(this)
    this.checkIfOrderDay = this.checkIfOrderDay.bind(this)
    this.getUnansweredSurveys = this.getUnansweredSurveys.bind(this)
    this.getBanners = this.getBanners.bind(this)
    this.handleSetFreeTextAnswer = this.handleSetFreeTextAnswer.bind(this)
    this.handleSetScoreAnswer = this.handleSetScoreAnswer.bind(this)
    this.handleModalWelcomeMessageClose = this.handleModalWelcomeMessageClose.bind(this)
    this.handleModalPromotionalMessageClose = this.handleModalPromotionalMessageClose.bind(this)
    this.handleModalSurveyClose = this.handleModalSurveyClose.bind(this)
    this.handleModalBannerClose = this.handleModalBannerClose.bind(this)
    this.handleSaveSurveyAnswers = this.handleSaveSurveyAnswers.bind(this)
    this.handleOmitSurvey = this.handleOmitSurvey.bind(this)
    this.handleOmitBanner = this.handleOmitBanner.bind(this)
    this.handleModalPendingAppointmentsClose = this.handleModalPendingAppointmentsClose.bind(this)
    this.getAppointments = this.getAppointments.bind(this)

    let currentAccount = getCurrentAccount()
    let systemConfig = getSystemConfig()
    this.state = {
      currentAccount: currentAccount ? currentAccount : { name: 'Seleccionar cuenta' },
      currentUser: getSessionData().loggedUser,
      overlayshow: true,
      isOrderDay: false,
      buttonTextSize: 'x-small',
      navigation: navigation,
      initNavigation: true,
      welcomeMessage: systemConfig ? systemConfig.welcomeMessage : null,
      isModalWelcomeMessageOpened: !!systemConfig && systemConfig.showWelcomeMessage,
      promotionalMessage: null,
      isModalPromotionalMessageOpened: false,
      unansweredSurveys: null,
      isModalSurveyOpened: false,
      surveyAnswers: [],
      banners: null,
      nextBannerIndex: 0,
      isModalBannerOpened: false,
      isFullView: getCurrentFullViewState(),
      surveysDownloaded: false,
      bannersDownloaded: false,
      reportsMenu: [],
      reportsDownloaded: false,
      pendingAppointments: null,
      isModalPendingAppointmentsOpened: false
    }
  }

  componentDidMount() {

    var browser = detect()
    switch (browser && browser.name) {
      case 'chrome':
      case 'firefox':
        break
      default:
        toast.error('Navegador no soportado!', {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000
        })
        toast.error('Por favor use Chrome o Firefox', {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000
        })
        console.error('Navegador no soportado! Por favor use Chrome o Firefox')
    }

    this.timerID = setInterval(() => this.tick(), 1000)
  }

  componentWillUnmount() {
    clearInterval(this.timerID)
  }

  componentDidUpdate(prevProps, prevState) {
    const accountChanged =
      prevState.currentAccount &&
      this.state.currentAccount &&
      prevState.currentAccount.id !== this.state.currentAccount.id

    const isFullViewChanged = prevState.isFullView !== this.state.isFullView

    if (accountChanged) {
      this.setState(
        {
          reportsDownloaded: false,
          reportsMenu: []
        },
        () => {
          this.getReportsMenu()
        }
      )
    }

    if (isFullViewChanged) {
      let newNavigation = { ...this.state.navigation }

      Object.values(newNavigation.items).forEach((item) =>
        this.toggleNavigationItem(item, this.state.currentAccount, this.state.isFullView)
      )

      this.toggleReportsSection(newNavigation)

      this.setState({ 
        navigation: newNavigation,
        isFullView: this.state.isFullView 
      })
    }

    const reportsChanged =
      prevState.reportsMenu.length !== this.state.reportsMenu.length ||
      (prevState.reportsDownloaded !== this.state.reportsDownloaded &&
        this.state.reportsDownloaded)

    if (reportsChanged || (accountChanged && this.state.reportsDownloaded)) {
      let newNavigation = { ...this.state.navigation }

      Object.values(newNavigation.items).forEach((item) =>
        this.toggleNavigationItem(item, this.state.currentAccount, this.state.isFullView)
      )

      this.toggleReportsSection(newNavigation)

      this.setState({ navigation: newNavigation })
    }
  }

  tick() {
    let currentAccount = getCurrentAccount()
    let selectedCustomerHasChanged = currentAccount.id !== this.state.currentAccount.id
    let isFullView = getCurrentFullViewState()
    let isFullViewChanged = isFullView !== this.state.isFullView

    if (isFullViewChanged) {
      this.setState({ isFullView: isFullView })
    }

    if (
      (this.state.promotionalMessage == null || selectedCustomerHasChanged) &&
      currentAccount.mostrarMensajePromocional
    ) {
      this.setState({
        promotionalMessage: currentAccount.mensajePromocional,
        isModalPromotionalMessageOpened: !this.state.isModalWelcomeMessageOpened
      })
    }

    if (
      (selectedCustomerHasChanged ||
        (!this.state.surveysDownloaded && this.state.unansweredSurveys == null)) &&
      currentAccount.id
    ) {
      this.setState({ surveysDownloaded: true })
      this.getUnansweredSurveys(currentAccount.id)
    }

    if (
      (selectedCustomerHasChanged ||
        (!this.state.reportsDownloaded && this.state.reportsMenu.length === 0)) &&
      currentAccount.id
    ) {
      this.getReportsMenu()
    }

    if (
      (selectedCustomerHasChanged ||
        (!this.state.bannersDownloaded && this.state.banners == null)) &&
      currentAccount.id
    ) {
      this.setState({ bannersDownloaded: true })
      this.getBanners(currentAccount.id)
    }

    if (this.state.initNavigation && this.state.reportsDownloaded) {
      let newNavigation = { ...navigation }
      Object.values(newNavigation.items).forEach((item) =>
        this.toggleNavigationItem(item, currentAccount, isFullView)
      )
      this.toggleReportsSection(newNavigation)

      this.setState({
        initNavigation: false,
        navigation: newNavigation,
        isFullView: isFullView
      })
    }

    if (!currentAccount || selectedCustomerHasChanged) {
      this.setState({
        currentAccount: currentAccount
      })
    }

    if (this.state.pendingAppointments === null) this.getAppointments()
  }

  toggleNavigationItem(item, currentAccount, isFullViews) {
    if (!item.class || !item.isHidden) return

    let isHidden = item.isHidden(currentAccount, isFullViews)
    if (item.title) {
      item['class'] = item.class.replace('d-none', '') + (isHidden ? ' d-none' : '')
    } else {
      item['attributes'] = { hidden: isHidden }
    }
  }

  isAccountActive(account) {
    if (!account) return false

    if (typeof account.activo === 'boolean') {
      return account.activo
    }

    return false
  }

  toggleReportsSection(newNavigation) {
    const isFullView = this.state.isFullView

    const reportSection = newNavigation.items.find(
      (item) => !!item.class && item.class.includes('nav-my-reports')
    )

    const reportsSectionIndex = newNavigation.items.findIndex(
      (item) => item.class && item.class.includes('nav-my-reports-section')
    )

    if (isFullView) {
      if (reportSection) {
        reportSection.class = (reportSection.class || '').replace('d-none', '').trim()
      }
    } else {
      const isActive = this.isAccountActive(this.state.currentAccount)

      if (!isActive) {
        if (reportSection) {
          if (!reportSection.class.includes('d-none')) {
            reportSection.class = (reportSection.class || '') + ' d-none'
          }
        }

        newNavigation.items.forEach((item) => {
          if (item.url && item.url.startsWith('/web-group-report/')) {
            item.attributes = { hidden: true }
          }
        })

        return
      }

      if (reportSection) {
        reportSection.class = (reportSection.class || '').replace('d-none', '').trim()
      }
    }

    if (this.state.reportsMenu.length === 0) return

    if (reportsSectionIndex === -1) {
      return
    }

    let reportsMenuEndIndex = newNavigation.items.findIndex(
      (item, index) => index > reportsSectionIndex && item.title
    )

    if (reportsMenuEndIndex === -1) {
      reportsMenuEndIndex = newNavigation.items.length
    } else {
      reportsMenuEndIndex -= 1
    }

    newNavigation.items = newNavigation.items.filter(
      (item) => !(item.url && item.url.startsWith('/web-group-report/'))
    )

    const newReportsSectionIndex = newNavigation.items.findIndex(
      (item) => item.class && item.class.includes('nav-my-reports-section')
    )

    newNavigation.items.splice(newReportsSectionIndex + 1, 0, ...this.state.reportsMenu)
  }

  checkIfOrderDay() {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/Route/IsOrderDay/${this.state.currentAccount.external_Id__c}`
      )
      .then(({ data }) => {
        if (!data.isError) {
          if (data.data !== null) {
            var date = new Date(data.data)
            var time = addZero(date.getHours()) + ':' + addZero(date.getMinutes())
            this.setState({
              isOrderDay: true,
              isOrderDayMessage: 'Realice su pedido antes de las ' + time
            })
          }
        } else {
          console.error(data.errorMessage)
        }
      })
      .catch(function (error) {
        console.error(error)
      })
  }

  async getAppointments() {
    const lastWeek = new Date()
    lastWeek.setDate(lastWeek.getDate() - 7)

    try {
      const { data } = await getPendingAppointments({
        page: 0,
        pageSize: 0,
        sorted: [],
        filtered: [
          {
            id: 'initDate',
            value: lastWeek
          },
          {
            id: 'endDate',
            value: new Date()
          }
        ]
      })
      this.setState({ pendingAppointments: data })
      this.state.isModalPendingAppointmentsOpened = true
    } catch (error) {
      console.error(error)
    }
  }

  getUnansweredSurveys(customerId) {
    axios
      .post(`${process.env.REACT_APP_API_URL}/api/Surveys/GetUnansweredSurveys/`, {
        customerId: customerId
      })
      .then(({ data }) => {
        if (data.isError) {
          console.error(data.errorMessage)
        } else {
          this.setState({
            unansweredSurveys: data.data,
            isModalSurveyOpened:
              !!data.data.length &&
              !this.state.isModalWelcomeMessageOpened &&
              !this.state.isModalPromotionalMessageOpened
          })
          if (data.data.length) {
            let answers = this.state.unansweredSurveys[0].questions.map((question) => ({
              questionId: question.id,
              freeText: null,
              score: null,
              isOmitted: false
            }))
            this.setState({ surveyAnswers: answers })
          }
        }
      })
      .catch(function (error) {
        console.error(error)
      })
      .finally(() => {
        this.setState({ surveysDownloaded: false })
      })
  }

  getReportsMenu() {
    const isActive = this.isAccountActive(this.state.currentAccount)
    const isFullView = this.state.isFullView

    if (!isActive && !isFullView) {
      this.setState({ reportsDownloaded: true })
      return
    }

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/WebGroupReport/all`)
      .then(({ data }) => {
        if (data.isError) {
          console.error(data.errorMessage)
        } else {
          this.generateReportsMenu([...data.data])
        }
      })
      .catch(function (error) {
        console.error(error)
      })
      .finally(() => {
        this.setState({ reportsDownloaded: true })
      })
  }

  generateReportsMenu(reports) {
    if (reports.length) {
      let reportsMenu = reports.map((report) => ({
        name: report.shortName,
        class: '',
        url: `/web-group-report/${report.id}`,
        icon: 'icon-docs',
        attributes: { hidden: false }
      }))
      this.setState({ reportsMenu: reportsMenu })
    }
  }

  getBanners(customerId) {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/HomeBanners/?customerId=${customerId}`)
      .then(({ data }) => {
        if (data.isError) {
          console.error(data.errorMessage)
        } else {
          const { pathname } = this.props.location
          this.setState({
            banners: data.data.map((banner, index) => ({
              ...banner,
              show: index === 0
            })),
            isModalBannerOpened:
              !!data.data.length &&
              !this.state.isModalSurveyOpened &&
              !this.state.isModalWelcomeMessageOpened &&
              !this.state.isModalPromotionalMessageOpened &&
              pathname.includes('/accountdashboard'),

            nextBannerIndex: 1
          })
        }
      })
      .catch(function (error) {
        console.error(error)
      })
      .finally(() => {
        this.setState({ bannersDownloaded: false })
      })
  }

  renderLinkPedido1() {
    if (
      this.state.currentAccount !== undefined &&
      this.state.currentAccount !== null &&
      this.state.currentAccount.urlPedidos1__c !== null &&
      this.state.currentAccount.urlPedidos1__c !== undefined
    ) {
      var split = this.state.currentAccount.urlPedidos1__c.split('#')
      var title = split[0]
      var url = split.slice(1, split.length).join()

      return (
        <div
          className="linkPortal"
          style={{
            cursor: 'pointer',
            float: 'left',
            fontSize: this.state.buttonTextSize
          }}
          onClick={(event) => this.handleClickLinkPortal(event, url)}
        >
          <i className="icon-share-alt" style={{ fontSize: 'small', color: 'white' }} /> {title}
        </div>
      )
    } else {
      return null
    }
  }

  renderLinkPedido2() {
    if (
      this.state.currentAccount !== undefined &&
      this.state.currentAccount !== null &&
      this.state.currentAccount.urlPedidos2__c !== null &&
      this.state.currentAccount.urlPedidos2__c !== undefined
    ) {
      var split = this.state.currentAccount.urlPedidos2__c.split('#')
      var title = split[0]
      var url = split.slice(1, split.length).join()

      return (
        <div
          className="linkPortal"
          style={{
            cursor: 'pointer',
            float: 'left',
            fontSize: this.state.buttonTextSize
          }}
          onClick={(event) => this.handleClickLinkPortal(event, url)}
        >
          <i className="icon-share-alt" style={{ fontSize: 'small', color: 'white' }} /> {title}
        </div>
      )
    } else {
      return null
    }
  }

  renderLinkDiasPedido() {
    return (
      this.state.currentAccount.mostrarSeccionMisDiasDePedidoEntrega && this.state.currentAccount.activo  && (
        <div
          className="linkPortal"
          style={{
            cursor: 'pointer',
            float: 'right',
            fontSize: this.state.buttonTextSize
          }}
          onClick={(event) => this.handleClickLinkPortal(event, 'DIAS')}
        >
          <i className="icon-calendar" style={{ fontSize: 'small', color: 'white' }} /> Mis días de
          pedido y entrega
        </div>
      )
    )
  }

  handleClickLinkPortal(e, src) {
    e.preventDefault()
    var win = null
    if (src === 'DIAS') {
      window.location.replace('/#/routes')
    } else {
      win = window.open(src, '_blank')
    }
    if (win !== null) {
      win.focus()
    }
  }

  renderContactBreadcrumb() {
    return (
      <div className="breadcrumb">
        <Row>
          <Col xs="12" sm="6" lg="4" style={{ padding: '0px', textAlign: 'center' }}>
            {this.renderLinkPedido1()}
            {this.renderLinkPedido2()}
          </Col>
          <Col
            xs="12"
            sm="6"
            lg="4"
            style={{ padding: '1px', textAlign: 'center' }}
            className="d-sm-down-none "
          >
            {this.state.isOrderDay ? (
              <span
                className="alert alert-danger"
                role="alert"
                style={{
                  textAlign: 'center',
                  marginBottom: '0',
                  padding: '4px',
                  top: '5px'
                }}
              >
                <i className="fa fa-warning  pr-1" style={{ marginRight: '10px' }} />
                {this.state.isOrderDayMessage}
              </span>
            ) : null}
          </Col>

          <Col xs="12" sm="6" lg="4" style={{ padding: '0px', textAlign: 'center' }}>
            {this.renderLinkDiasPedido()}
          </Col>
        </Row>
      </div>
    )
  }

  handleModalWelcomeMessageClose() {
    let showPromotionalMessage = this.state.promotionalMessage != null
    let showSurvey = this.state.unansweredSurveys != null && !!this.state.unansweredSurveys.length
    let showBanner = this.state.banners != null && !!this.state.banners.length
    this.setState({
      isModalWelcomeMessageOpened: false,
      isModalPromotionalMessageOpened: showPromotionalMessage,
      isModalSurveyOpened: !showPromotionalMessage && showSurvey,
      isModalBannerOpened: !showPromotionalMessage && !showSurvey && showBanner
    })
  }

  handleModalPendingAppointmentsClose() {
    this.setState({ isModalPendingAppointmentsOpened: false })
  }

  handleModalPromotionalMessageClose() {
    let showSurvey = this.state.unansweredSurveys != null && !!this.state.unansweredSurveys.length
    let showBanner = this.state.banners != null && !!this.state.banners.length
    this.setState({
      isModalPromotionalMessageOpened: false,
      isModalSurveyOpened: showSurvey,
      isModalBannerOpened: !showSurvey && showBanner
    })
  }

  handleModalSurveyClose() {
    let showBanner = this.state.banners != null && !!this.state.banners.length
    this.setState({
      isModalSurveyOpened: false,
      isModalBannerOpened: showBanner
    })
  }

  handleModalBannerClose() {
    if (this.state.nextBannerIndex < this.state.banners.length) {
      this.setState({
        nextBannerIndex: this.state.nextBannerIndex + 1,
        banners: this.state.banners.map((banner, index) => ({
          ...banner,
          show: index === this.state.nextBannerIndex
        }))
      })
    } else {
      this.setState({ isModalBannerOpened: false })
    }
  }

  handleSetFreeTextAnswer(questionId, freeText) {
    let newSurveyAnswers = [...this.state.surveyAnswers]
    let oldAnswer = newSurveyAnswers.find((answer) => answer.questionId === questionId)
    oldAnswer.freeText = freeText
    this.setState({ surveyAnswers: newSurveyAnswers })
  }

  handleSetScoreAnswer(questionId, score) {
    let newSurveyAnswers = [...this.state.surveyAnswers]
    let oldAnswer = newSurveyAnswers.find((answer) => answer.questionId === questionId)
    oldAnswer.score = parseInt(score, 10)
    this.setState({ surveyAnswers: newSurveyAnswers })
  }

  handleOmitSurvey() {
    let newSurveyAnswers = [...this.state.surveyAnswers].map((answer) => {
      answer.isOmitted = true
      return answer
    })
    this.setState({ surveyAnswers: newSurveyAnswers })
  }

  handleOmitBanner() {
    axios
      .post(`${process.env.REACT_APP_API_URL}/api/HomeBanners/`, {
        customerId: this.state.currentAccount.id,
        bannerId: this.state.banners[this.state.nextBannerIndex - 1].id
      })
      .then(({ data }) => {
        if (data.isError) {
          toast.error('Error! ' + data.errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000
          })
          console.error(data.errorMessage)
        }
      })
      .finally(this.handleModalBannerClose)
      .catch((error) => console.error(error))
  }

  handleSaveSurveyAnswers(event, omitSurvey = false) {
    if (omitSurvey) {
      this.handleOmitSurvey()
    } else {
      const questions = this.state.unansweredSurveys[0].questions
      let scoresNotAnswered = this.state.surveyAnswers.find(
        (answer) =>
          questions.find((question) => question.id === answer.questionId && question.hasScore) &&
          answer.score == null
      )
      if (scoresNotAnswered) return
    }
    axios
      .post(`${process.env.REACT_APP_API_URL}/api/Surveys/AddAnswers/`, {
        surveyId: this.state.unansweredSurveys[0].id,
        customerId: this.state.currentAccount.id,
        answers: this.state.surveyAnswers
      })
      .then(({ data }) => {
        if (data.isError) {
          toast.error('Error! ' + data.errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000
          })
          console.error(data.errorMessage)
        } else {
          toast.success(omitSurvey ? '¡Encuesta omitida!' : '¡Respuestas enviadas!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000
          })
        }
      })
      .finally(this.handleModalSurveyClose)
      .catch((error) => console.error(error))
  }

  handleGoToBannerUrl() {
    window.open(
      this.state.banners[this.state.nextBannerIndex - 1].redirectionUrl,
      '_blank',
      'noreferrer'
    )
  }

  handleSendActivityLogPublicity() {
    sendActivityLog({
      sectionId: sections.Summary,
      pageId: pages.Summary,
      eventId: events.UserClickAdvertisingSummary
    })
  }

  navigateToAppointment(id) {
    this.handleModalPendingAppointmentsClose()
    this.props.history.push(`/routes-vendor/${id}`)
  }

  render() {
    return (
      <div className="app">
        <ToastContainer />
        <AppHeader fixed>
          <DefaultHeader />
        </AppHeader>
        <div className="app-body">
          <AppSidebar fixed display="lg">
            <AppSidebarHeader />
            <AppSidebarForm />
            <AppSidebarNav navConfig={this.state.navigation} {...this.props} />
            <AppSidebarFooter />
          </AppSidebar>
          <div className="main">
            {this.renderContactBreadcrumb()}

            <Container fluid>
              <Switch>
                {routes.map((route, idx) => {
                  return route.component ? (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={(props) =>
                        !route.isAllowed || route.isAllowed() ? (
                          <route.component {...props} />
                        ) : (
                          <Redirect to={{ pathname: '/' }} />
                        )
                      }
                    />
                  ) : null
                })}
                <Redirect from="/" to="/accountdashboard" />
              </Switch>
            </Container>
          </div>
          <AppAside fixed hidden>
            <DefaultAside />
          </AppAside>
        </div>
        <AppFooter>
          <DefaultFooter />
        </AppFooter>

        <Modal
          isOpen={this.state.isModalWelcomeMessageOpened}
          toggle={this.handleModalWelcomeMessageClose}
        >
          <ModalBody>
            <div dangerouslySetInnerHTML={{ __html: this.state.welcomeMessage }} />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.handleModalWelcomeMessageClose}>
              Cerrar
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          size="xl"
          isOpen={
            this.state.isModalPendingAppointmentsOpened && !!this.state.pendingAppointments.length
          }
          toggle={this.handleModalPendingAppointmentsClose}
        >
          <ModalBody>
            <h3>Citas pendientes de los últimos 7 días</h3>
            {this.state.pendingAppointments != null && !!this.state.pendingAppointments.length && (
              <Row>
                {this.state.pendingAppointments.map((appointment) => (
                  <Col lg={6} key={appointment.id} className="mb-4">
                    <Card>
                      <CardHeader className="d-flex justify-content-between">
                        <p className="pt-2 mb-2">
                          <i className="fa fa-calendar"></i>
                          <span className="pl-2">
                            {appointment.customerName
                              ? appointment.customerName
                              : appointment.title
                                ? appointment.title
                                : 'Cita'}
                          </span>
                        </p>
                        <Button
                          size="xs"
                          color="danger"
                          onClick={() => this.navigateToAppointment(appointment.id)}
                        >
                          Ir a cita
                        </Button>
                      </CardHeader>
                      <CardBody>
                        <Row className="row-eq-height">
                          <Col lg={4}>Fecha</Col>
                          <Col lg={8}>{moment(appointment.start).format('DD/MM/YYYY')}</Col>
                        </Row>
                        <Row className="row-eq-height">
                          <Col lg={4}>Hora</Col>
                          <Col lg={8}>{moment(appointment.start).format('HH:mm')}</Col>
                        </Row>
                        <Row className="row-eq-height">
                          <Col lg={4}>Dirección</Col>
                          <Col lg={8}>{appointment.clientAddress}</Col>
                        </Row>
                        <Row className="row-eq-height">
                          <Col lg={4}>Motivo</Col>
                          <Col lg={8}>{Reason[appointment.reason]}</Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            )}
          </ModalBody>
          <ModalFooter>
            <Button onClick={this.handleModalPendingAppointmentsClose} color="secondary">
              Cerrar
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={this.state.isModalPromotionalMessageOpened}
          toggle={this.handleModalPromotionalMessageClose}
        >
          <ModalBody>
            <div
              dangerouslySetInnerHTML={{
                __html: this.state.promotionalMessage
              }}
            />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.handleModalPromotionalMessageClose}>
              Cerrar
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={this.state.isModalSurveyOpened}
          toggle={this.handleModalSurveyClose}
          size="lg"
        >
          <ModalHeader toggle={this.handleModalSurveyClose}>
            {this.state.unansweredSurveys != null && !!this.state.unansweredSurveys.length
              ? this.state.unansweredSurveys[0].title
              : ''}
          </ModalHeader>
          <ModalBody>
            {this.state.unansweredSurveys != null &&
              !!this.state.unansweredSurveys.length &&
              this.state.unansweredSurveys[0].questions.map((question) => (
                <Card key={question.id}>
                  <CardBody>
                    <div dangerouslySetInnerHTML={{ __html: question.text }} />
                    {question.hasFreeText && (
                      <div className="mt-2">
                        <Label for={`free-text-${question.id}`} className="small form-label">
                          Respuesta
                        </Label>
                        <Input
                          id={`free-text-${question.id}`}
                          className="form-control"
                          onChange={(ev) =>
                            this.handleSetFreeTextAnswer(question.id, ev.target.value)
                          }
                        />
                      </div>
                    )}
                    {question.hasScore && (
                      <div className="mt-2">
                        <Label for={`score-${question.id}`} className="small form-label">
                          Puntuación
                        </Label>
                        <select
                          id={`score-${question.id}`}
                          className="form-control"
                          onChange={(ev) => this.handleSetScoreAnswer(question.id, ev.target.value)}
                        >
                          <option value="" disabled selected>
                            Seleccione una puntuación
                          </option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                        </select>
                      </div>
                    )}
                  </CardBody>
                </Card>
              ))}
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={this.handleModalSurveyClose}
              size={window.innerWidth < 500 ? 'xs' : 'sm'}
            >
              Participar más tarde
            </Button>
            <Button
              color="secondary"
              onClick={(e) => this.handleSaveSurveyAnswers(e, true)}
              size={window.innerWidth < 500 ? 'xs' : 'sm'}
            >
              No deseo participar
            </Button>
            <Button
              className="btn btn-conway"
              onClick={this.handleSaveSurveyAnswers}
              size={window.innerWidth < 500 ? 'xs' : 'sm'}
            >
              Enviar respuestas
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={this.state.isModalBannerOpened}
          toggle={this.handleModalBannerClose}
          size="lg"
        >
          <ModalHeader toggle={this.handleModalBannerClose}></ModalHeader>
          <ModalBody className="p-0">
            {this.state.banners != null &&
              !!this.state.banners.length &&
              this.state.banners.map((banner) =>
                banner.show && banner.contentUrl ? (
                  <div key={`banner-${banner.id}`} className="text-center">
                    {banner.contentUrl.match(/\.(jpeg|jpg|gif|png|svg)(\?.*)?$/) ? (
                      banner.redirectionUrl ? (
                        <a href={banner.redirectionUrl} target="_blank">
                          <img
                            title={banner.redirectionUrl}
                            src={banner.contentUrl}
                            alt="Banner"
                            style={{ width: '99%' }}
                          />
                        </a>
                      ) : (
                        <img src={banner.contentUrl} alt="Banner" style={{ width: '99%' }} />
                      )
                    ) : (
                      <iframe
                        src={banner.contentUrl}
                        title="Banner"
                        style={{ width: '100%', height: '500px', border: 0 }}
                      />
                    )}
                  </div>
                ) : (
                  ''
                )
              )}
          </ModalBody>
          <ModalFooter>
            <Button
              disabled={
                !this.state.banners ||
                !this.state.banners.length ||
                !this.state.banners[this.state.nextBannerIndex - 1] ||
                !this.state.banners[this.state.nextBannerIndex - 1].redirectionUrl
              }
              color="secondary"
              onClick={(_) => {
                this.handleGoToBannerUrl()
                this.handleSendActivityLogPublicity()
              }}
              size={window.innerWidth < 500 ? 'xs' : 'sm'}
            >
              Navegar
            </Button>
            <Button
              color="secondary"
              onClick={(e) => this.handleOmitBanner(e)}
              size={window.innerWidth < 500 ? 'xs' : 'sm'}
            >
              No volver a mostrar
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default DefaultLayout
